import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { designTypesEnum } from "../../../../../../Helpers/EnumHelper";
import IconSvg from "../../../../../SharedComponents/IconSvg";
import { AdminActions, AdminButton, ConfirmDeleteButton } from "../../../../SharedComponents/ListView";
import { updateReportItemBase } from "../../ReportItemBase/Store";
import { setIsHtml, setRgbColor, setScales } from "../../../ScoringScale/Store";
import EntityInfoModal from "../../../ReportScheme/Components/Entities/EntityInfoModal/EntityInfoModal";
import { setEntityModalInfo } from "../../../ReportScheme/Store";

export default function ReportItemEntityList(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const entityModalInfo = useSelector((state) => state.reportScheme.entityModalInfo);

  const ShowEntityModal = (entity) => {
    dispatch(setEntityModalInfo({ isShown: true, entity }));
  };

  const GetKeyByValue = (value) => {
    return Object.keys(designTypesEnum).find((key) => designTypesEnum[key] === value);
  };

  const DeleteEntity = (id) => {
    dispatch(props.DeleteFunction({ id }));
  };

  const SeeDetailAndUpdate = (entity) => {
    dispatch(updateReportItemBase({ key: "name", value: entity.name }));
    dispatch(updateReportItemBase({ key: "designType", value: entity.designType }));
    dispatch(setScales(entity.scale.ranges));
    dispatch(setIsHtml(entity.scale.isHtml));
    dispatch(setRgbColor(entity.scale.rgbColor));
    dispatch(props.UpdateStateId({ id: entity.id }));
    if (props.UpdateRelatedState) props.UpdateRelatedState(entity);
  };

  return (
    <>
      {props?.entityList?.map((entity, i) => (
        <Card className="mb-3" key={i}>
          <Card.Body className={entity.id === props.id && "dashed-border"}>
            <Row>
              <Col>
                <h6>{entity.id}</h6>
              </Col>
              <Col>
                <h6>{entity.name}</h6>
              </Col>
              <Col>
                <h6>{GetKeyByValue(entity.designType)}</h6>
              </Col>
              <Col className="flex-center">
                <AdminActions>
                  <AdminButton
                    onClick={() => ShowEntityModal(entity)}
                    title={t("preview")}
                    aria-label={t("preview")}
                  >
                    <IconSvg icon="eye" fill="#fff" />
                  </AdminButton>
                  <AdminButton variant="outline" onClick={() => SeeDetailAndUpdate(entity)}>
                    {t("detail")}
                  </AdminButton>
                </AdminActions>
              </Col>
              <Col>
                <AdminActions>
                  <ConfirmDeleteButton onConfirm={() => DeleteEntity(entity.id)}>
                    <IconSvg icon="trash-can" fill="#fff" />
                  </ConfirmDeleteButton>
                </AdminActions>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      ))}

      {entityModalInfo.isShown && <EntityInfoModal isShown={entityModalInfo.isShown} entity={entityModalInfo.entity} />}
    </>
  );
}
